import { RED, INK, GREY, IVORY, DARK, LINE, paras, compact, hr, vr, dot } from "./povPages";

// Troisième document : coordonnées exactes du PDF (canevas 960 x 540).
export function buildPovPages3(insight) {
  const b = insight.blocks;
  const pages = [];

  const eyebrow = (text) => ({ x: 44, y: 46, size: 8.5, bold: true, color: RED, upper: true, ls: "0.14em", text });
  const title = (text, w, size = 25, y = 78, lh = 1.12) => ({ x: 44, y, w, size, serif: true, bold: true, color: INK, lh, text });
  const lead = (text, y, w, size = 10.8) => ({ x: 44, y, w, size, color: INK, lh: 1.47, text });
  const itemsTitle = (text, x = 525, y = 189, w = 330, size = 17) => ({ x, y, w, size, serif: true, bold: true, color: INK, lh: 1.2, text });
  const footnote = (text, w = 560) => ({ x: 44, y: 495, w, size: 6.4, color: GREY, lh: 1.4, text });

  // 01 — couverture
  pages.push({
    bg: DARK,
    bar: RED,
    barW: 14,
    image: { src: insight.image, x: 510, y: 0, w: 450, h: 540 },
    rects: [hr(54, 372, 378, 3)],
    items: [
      { x: 54, y: 137, w: 435, size: 31, serif: true, bold: true, color: "#ffffff", lh: 1.13, text: insight.title },
      { x: 54, y: 405, w: 390, size: 15, bold: true, color: "#ffffff", lh: 1.3, text: insight.subtitle },
    ],
  });

  // 02 — introduction
  {
    const k = b[0];
    const [p1, p2] = paras(k.lead);
    pages.push({
      rects: [
        hr(44, 916, 138),
        { x: 486, y: 185, w: 430, h: 277, fill: IVORY },
        { x: 486, y: 185, w: 5, h: 277, fill: RED },
      ],
      items: [
        eyebrow(k.eyebrow),
        title(k.title, 800),
        lead(p1, 187, 398, 11.1),
        lead(p2, 338, 398, 11.1),
        { x: 526, y: 229, w: 345, size: 24, serif: true, bold: true, color: INK, lh: 1.21, text: k.quote },
        { x: 526, y: 347, w: 345, size: 11, color: GREY, lh: 1.45, text: k.after },
      ],
    });
  }

  // 03 — synthèse
  {
    const k = b[1];
    const items = [eyebrow(k.eyebrow), title(k.title, 620)];
    k.items.forEach((it, i) => {
      const y = 191 + 79 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 44, y: y + 1, size: 10, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 102, y, w: 330, size: 14.2, bold: true, color: INK, lh: 1.19, text: it.label, mobileNum: n });
      items.push({ x: 460, y: y - 2, w: 435, size: 9.8, color: GREY, lh: 1.43, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[233, 312, 391].map((y) => hr(102, 890, y, 0.7, LINE))], items });
  }

  // 04 — quatre dimensions
  {
    const k = b[2];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 700),
      { x: 44, y: 143, w: 820, size: 10.3, color: GREY, lh: 1.4, text: k.lead },
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const x = i % 2 === 0 ? 44 : 490;
      const y = i < 2 ? 214 : 344;
      items.push({ x, y, w: 180, size: 15, bold: true, color: i === 0 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: x + 165, y: y - 3, w: 235, size: 9.8, color: GREY, lh: 1.43, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 160), hr(44, 439, 293, 0.7, LINE), hr(490, 885, 293, 0.7, LINE)], items });
  }

  // 05 / 09 / 13 — ouvertures de partie
  const part = (k) => ({
    bg: "#0a0a0a",
    bar: RED,
    barW: 15,
    image: { src: k.image, x: 0, y: 0, w: 960, h: 540, overlay: true },
    rects: [hr(55, 390, 294, 0.8, "#ffffff")],
    items: [
      { x: 55, y: 129, w: 690, size: 35, serif: true, bold: true, color: "#ffffff", lh: 1.1, text: k.title },
      { x: 55, y: 321, w: 540, size: 13, color: "#ffffff", lh: 1.38, text: k.lead },
    ],
  });

  pages.push(part(b[3]));

  // 06 / 10 — listes de cinq entrées
  const listPage = (k, titleSize, titleY, titleW) => {
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, titleW, titleSize, titleY, 1.14),
      lead(p1, 172, 450),
      lead(p2, titleY === 77 ? 336 : 320, 450),
      itemsTitle(k.itemsTitle),
    ];
    k.items.forEach((it, i) => {
      const y = 232 + 50 * i;
      items.push({ x: 525, y, w: 150, size: 10.5, bold: true, color: INK, lh: 1.2, text: it.label });
      items.push({ x: 665, y: y - 1, w: 210, size: 9, color: GREY, lh: 1.42, text: it.text });
    });
    if (k.footnote) items.push(footnote(k.footnote));
    return { rects: [hr(44, 916, 138), ...[255, 305, 355, 405].map((y) => hr(525, 875, y, 0.6, LINE))], items };
  };

  pages.push(listPage(b[4], 20, 77, 780));

  // 07 — réel et artificiel
  {
    const k = b[5];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 740),
      lead(k.lead, 172, 450, 11),
      { x: 68, y: 327, w: 345, size: 15.5, serif: true, bold: true, color: INK, lh: 1.3, text: k.quote },
      { x: 68, y: 404, w: 335, size: 10.5, color: GREY, lh: 1.44, text: k.after },
    ];
    k.items.forEach((it, i) => {
      const y = 200 + 63 * i;
      items.push({ x: 535, y, w: 120, size: 12, color: GREY, lh: 1.2, text: it.label });
      items.push({ x: 735, y, w: 145, size: 10.5, bold: true, color: INK, lh: 1.3, text: it.text });
    });
    pages.push({
      rects: [hr(44, 916, 138), { x: 44, y: 297, w: 400, h: 145, fill: IVORY }, ...[210, 273, 336, 399].map((y) => hr(666, 712, y, 1.4))],
      items,
    });
  }

  // 08 — exigence graduée
  {
    const k = b[6];
    const rects = [hr(44, 916, 138)];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 840, 23, 78, 1.14),
      lead(k.lead, 172, 430, 11),
      itemsTitle(k.itemsTitle, 500, 187, 300),
      { x: 44, y: 360, w: 365, size: 17, serif: true, bold: true, color: INK, lh: 1.24, text: k.after },
    ];
    k.items.forEach((it, i) => {
      const y = 224 + 62 * i;
      rects.push(dot(507, y, 22, i === 3 ? RED : DARK));
      if (i < 3) rects.push(vr(518, y + 23, y + 60, 1.2, LINE));
      items.push({ x: 548, y: y + 4, w: 160, size: 10.5, bold: true, color: INK, lh: 1.2, text: it.label });
      items.push({ x: 700, y: y + 3, w: 190, size: 9, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects, items });
  }

  pages.push(part(b[7]));

  pages.push(listPage(b[8], 23, 78, 810));

  // 11 — provenance
  {
    const k = b[9];
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 890, 23, 78, 1.14),
      lead(p1, 172, 450),
      lead(p2, 323, 450),
      itemsTitle(k.itemsTitle, 540, 215, 290, 16),
      footnote(k.footnote, 600),
    ];
    k.items.forEach((it, i) => {
      const y = 257 + 47 * i;
      items.push({ x: 540, y, w: 105, size: 9.5, bold: true, color: RED, lh: 1.2, text: it.label });
      items.push({ x: 645, y, w: 180, size: 8.8, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), { x: 510, y: 183, w: 370, h: 239, fill: IVORY }], items });
  }

  // 12 — méthode combinée
  {
    const k = b[10];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 870),
      lead(k.lead, 172, 400, 11),
      itemsTitle(k.itemsTitle, 500, 187, 300),
      { x: 68, y: 341, w: 330, size: 14, serif: true, bold: true, color: INK, lh: 1.3, text: k.quote },
    ];
    k.items.forEach((it, i) => {
      const y = 234 + 65 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 500, y: y + 1, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 548, y, w: 160, size: 11, bold: true, color: INK, lh: 1.25, text: it.label, mobileNum: n });
      items.push({ x: 700, y: y - 1, w: 185, size: 9, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({
      rects: [hr(44, 916, 138), { x: 44, y: 311, w: 380, h: 110, fill: IVORY }, ...[264, 329, 394].map((y) => hr(548, 875, y, 0.6, LINE))],
      items,
    });
  }

  pages.push(part(b[11]));

  // 14 — responsabilités
  {
    const k = b[12];
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 845, 23, 78, 1.14),
      lead(p1, 172, 460, 10.7),
      lead(p2, 342, 460, 10.7),
      { x: 525, y: 190, w: 330, size: 20, serif: true, bold: true, color: INK, lh: 1.24, text: k.asideText },
      footnote(k.footnote, 600),
    ];
    k.items.forEach((it, i) => {
      const y = 298 + 51 * i;
      items.push({ x: 525, y, w: 150, size: 10.5, bold: true, color: i === 0 ? RED : INK, lh: 1.25, text: it.label });
      items.push({ x: 680, y: y - 1, w: 185, size: 8.8, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[322, 373, 424].map((y) => hr(525, 875, y, 0.6, LINE))], items });
  }

  // 15 — discipline de décision
  {
    const k = b[13];
    const [p1, p2, p3] = paras(k.lead);
    const items = [eyebrow(k.eyebrow), title(k.title, 750), lead(p1, 172, 420), lead(p2, 292, 420), lead(p3, 422, 420), itemsTitle(k.itemsTitle, 525, 189, 260)];
    k.items.forEach((it, i) => {
      const y = 235 + 51 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 525, y: y + 1, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 570, y, w: 340, size: 11, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[256, 307, 358, 409].map((y) => hr(570, 875, y, 0.6, LINE))], items });
  }

  // 16 — conclusion
  {
    const k = b[14];
    pages.push({
      bg: DARK,
      bar: RED,
      barW: 15,
      rects: [hr(54, 388, 390, 3)],
      items: [
        { x: 54, y: 76, size: 9, bold: true, color: "#d6cec6", upper: true, ls: "0.16em", text: k.eyebrow },
        { x: 54, y: 127, w: 800, size: 31, serif: true, bold: true, color: "#ffffff", lh: 1.16, text: k.title },
        { x: 54, y: 274, w: 740, size: 18, bold: true, color: "#e8e0d8", lh: 1.33, text: k.lead },
        { x: 54, y: 419, w: 740, size: 11.5, color: "#cfc7bf", lh: 1.45, text: k.after },
      ],
    });
  }

  return pages.map((p) => compact(p));
}
